import React, { useState } from 'react';
import { HiPaperAirplane } from 'react-icons/hi';

const UserInput = ({ addMessage }) => {
  const [inputText, setInputText] = useState('');
  const inputRef = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim() !== '') {
      addMessage(inputText, 'user');
      setInputText('');

      // Refocus the input to keep the keyboard open on mobile
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  return (
    <div className="user-input">
      <form onSubmit={handleSubmit}>
        <input
          ref={inputRef}
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type a message..."
          enterKeyHint="send"
          autoComplete="off"
        />
        <button type="submit" disabled={!inputText.trim()}>
          <HiPaperAirplane size={20} />
        </button>
      </form>
    </div>
  );
};

export default UserInput;
